import { Component, OnChanges, Input, ElementRef, OnDestroy, SimpleChanges, OnInit } from '@angular/core';

import { DateHelperService, NumberFormatService } from '../../core/services';
import { ChartValue } from './chart-value.model';
import { ColorService } from "../../shared/color-service";
import { BarChartOptions } from "./bar-chart-options.model";

@Component({
    selector: 'bar-chart',
    template: `<div data-bar-chart style="height: 250px; padding: 0px; position: relative;"></div>`
})
export class BarChartComponent implements OnChanges, OnDestroy, OnInit {
    @Input() chartValues: ChartValue[];
    @Input() forceChange: any;
    @Input() toolTipText: string = "{0} {1}";
    @Input() options: BarChartOptions;
    private plot: any;
    private _options: BarChartOptions;
    private tooltipShadowOpacity : number = 0.3;
    private tooltipMaxWidth : number = 200;

    constructor(private el: ElementRef,
        private dateHelper: DateHelperService,
        private colorService: ColorService,
        private numberFormatService: NumberFormatService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        let plotArea = $(this.el.nativeElement).find('[data-bar-chart]').empty();
        this._options = this.options;
        this._options.legend = {
            show: true,
            container: $(plotArea).parent().nextAll(this.options.legendSelector).get(1)
        };
        let labels = this.chartValues.map(s => s.label);
        if (labels)
            this._options.colors = this.colorService.getColorsByNames(labels);
        this.plot = $.plot(plotArea, this.chartValues, this._options);

    }

    ngOnDestroy() {
        $("#tooltip").hide();
    }

    ngOnInit(): void {
        this.initToolTip();
    }

    private initToolTip(): void {
        if ($("div#tooltip").length === 0) {
            $("<div id='tooltip'></div>").css({
                position: "absolute",
                display: "none",
                "border-top": "3px solid",
                "border-right": "3px solid",
                "border-bottom": "3px solid",
                color: "white",
                padding: "8px",
                "background-color": "#222a33",
                opacity: 1,
				"max-width": this.tooltipMaxWidth + "px",
            }).appendTo("body");
        }

        $(this.el.nativeElement).on("plothover", (event, pos, item) => {
            if (item) {
                var series = this.plot.getData();
                var x = item.datapoint[0],
                    y = series[item.seriesIndex].data[item.dataIndex][1];
                
                // display the tooltip on the right/left side
				var tooltipSide = false;
				if($(window).width() - item.pageX < $('#tooltip').width()){
					tooltipSide = true;
				}
                var color_alpha = item.series.color;
                if(item.series.color.indexOf("rgba") === -1){
					color_alpha = item.series.color.replace(')', ',' + this.tooltipShadowOpacity + ')');
					color_alpha = color_alpha.replace('rgb', 'rgba');
				}
				else{
                    // regex to match the last value and replace it with the default opacity
					color_alpha = item.series.color.replace(/,([0-9]\.[0-9]+)\)/, ',' + this.tooltipShadowOpacity + ')');
				}
                var triangleClass = 'triangle';
                var triangleSmallClass = 'triangle-small';
                if (tooltipSide) {
                    triangleClass = 'triangle-br';
                    triangleSmallClass = 'triangle-small-br';
                }

                var labels = "<h1 style='text-overflow: ellipsis; overflow: hidden;white-space: nowrap;line-height:1.2;'>"+series[item.seriesIndex].label;
				if (this.chartValues.length > 0 && 0 == y){
					for (let i = 0; i < this.chartValues.length; i++) {
						if (this.chartValues[i].data[item.dataIndex][1] == 0 && this.chartValues[i].label != series[item.seriesIndex].label) {
							labels += ", " + this.chartValues[i].label;
						}
					}
				}
				labels += "</h1>";
                
                $("#tooltip").html(
                    "<span id='" + triangleClass + "'></span>" + "<span id='" + triangleSmallClass + "'></span>" +
                    this.toolTipText
                        .replace("{0}", "<span>" + this._options.tooltipCurrency + (this._options.roundTooltip ? Math.round(y) : this.numberFormatService.formatDecimal(y)) + "</span>")
                        .replace("{1}", "<span class='small muted' style='clear: both'>on: " + this.dateHelper.convertBackToDateFromTicks(x) + "</span>")
                        .replace("{2}", labels)
                    )
                    .css({
                        top: item.pageY + -90,
                        left: item.pageX + (tooltipSide ? 0 - $('#tooltip').width() - 25 : this._options.getTooltipLeft(window)),
                        "border-color": item.series.color,
                        "-webkit-box-shadow": "-1px 0px 43px 9px " + color_alpha,
                        "-moz-box-shadow": "-1px 0px 43px 9px " + color_alpha,
                        "box-shadow": "-1px 0px 43px 9px " + color_alpha
                    })
                    .fadeIn(200);

                if (tooltipSide) {
                    $("#triangle-br").css({ "border-color": item.series.color, })
                    $("#triangle-small-br").css({ "border-color": item.series.color, });
                } else {
                    $("#triangle").css({ "border-color": item.series.color, })
                    $("#triangle-small").css({ "border-color": item.series.color, })
                }
            } else {
                $("#tooltip").hide();
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/chart/bar-chart.component.ts